import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { map } from 'rxjs';
import { ClassState, ClassStore } from './class.store';
import { ClassStoreModel, ClassUIModel } from './class.model';

@Injectable({ providedIn: 'root' })
export class ClassQuery extends QueryEntity<ClassState, ClassStoreModel, ClassUIModel, 'id'> {
  constructor(protected override readonly store: ClassStore) {
    super(store);
  }

  readonly activeEntities$ = this.entities$.pipe(map((classes) => classes.filter((c) => !c.archived_at)));
}
